import { z } from 'zod/v4-mini';

import { useLocalizationStore } from '$/components/core/Localization/hooks/useLocalizationStore';
import { backendEndpoints } from '$/services/endpoints';
import { fetcher } from '$/services/fetcher';
import { type MaterialFilterOption } from '$/services/usecases/materials';
import { MaterialSchema } from '$/services/usecases/materials/mapper/materials';

export const SearchMaterialsSchema = z.object({
  '@odata.count': z.number(),
  value: z.array(MaterialSchema),
});

type Payload = {
  brightnessFilter?: number[];
  filter?: MaterialFilterOption[];
  limit?: number;
  order?: string;
  query?: string;
  skip?: number;
  signal?: AbortSignal;
  countryOverwrite?: string;
  isDemo?: boolean;
};

export const searchMaterials = async (payload: Payload = {}) => {
  const {
    filter,
    limit,
    order,
    query,
    skip,
    signal,
    countryOverwrite,
    isDemo,
  } = payload;
  const country = useLocalizationStore.getState().country;

  const response = await fetcher(backendEndpoints.MATERIAL_URL, {
    signal,
    body: {
      count: true,
      filter,
      order,
      query,
      skip: skip ?? 0,
      top: limit ?? 50,
      country: countryOverwrite ?? country,
      isDemo: isDemo ?? false,
    },
    method: 'POST',
    parser: (data) => SearchMaterialsSchema.parse(data),
    includeCredentials: true,
  });

  return {
    count: response.response['@odata.count'],
    results: response.response.value,
  };
};
